import { SVGProps } from 'react';

const MoveVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2v20m4-16-4-4-4 4m8 12-4 4-4-4"
    />
  </svg>
);
export default MoveVertical;
